import { RouteItem } from '@eastcoal/router/types/route'

export const securityRoute: RouteItem = {
  title: '账号安全',
  path: '/security',
  hideInMenu: true,
  Component: () => import('./index')
}
